export default __webpack_public_path__ + "static/media/siebe-chugelrundi-saeu.39ffa8d4.png";